import { GET_CASE_DETAILS, GET_CASE_NUMBER } from "../../actions/cases/getCaseNumberActions";

const initState = {
  caseNumber: "",
};

const getCaseNumberReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_CASE_NUMBER:
      return {
        ...state,
        caseNumber: action.caseNumber,
      };
    case GET_CASE_DETAILS:
      return {
        ...state,
        cases: action.payload,
      };
    default:
      return state;
  }
};

export default getCaseNumberReducer;
